import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import AccountPage from './pages/Profil/AccountPage';
import LoginPage from "./pages/Profil/LoginPage";
import RegisterPage from './pages/Profil/RegisterPage';
import TermsPage from './pages/TermsPage';
import PredictionsPage from './pages/Predictions/PredictionsPage';
import Faq from './pages/SliderPages/Faq';
import StrategiiPage from './pages/SliderPages/StrategiesPage';
import SoccerHighOddsPage from './pages/Predictions/SoccerHighOddsPage';
import GenerateSmallOddsPage from './pages/Generations/GenerateSmallOddsPage';
import GeneratedTicketPage from './pages/Generations/GeneratedTicketPage';
import WinningTicketsPage from './pages/Generations/WinningTicketsPage';
import GenerateHighOddsPage from './pages/Generations/GenerateHighOddsPage';
import GeneratedHighOddsTicket from './pages/Generations/GeneratedHighOddsTicket';
import ReviewsPage from './pages/Review/ReviewsPage';
import LeaveReviewPage from './pages/Review/LeaveReviewPage';
import BasketPage from './pages/Predictions/BasketPage';
import TennisPage from './pages/Predictions/TennisPage';
import SubscriptionsPage from './pages/Profil/SubscriptionsPage';
import HowToUsePage from './pages/HowToUsePage';
import BuySubscriptionPage from "./pages/Profil/BuySubscriptionPage";
import MySubscriptionPage from "./pages/Profil/MySubscriptionPage";
import {useAuth} from "./context/AuthContext";
import Loading from "./components/Loading";
import ContestPage from "./pages/ContestPage";
import ForgotPasswordPage from "./pages/Profil/ForgotPasswordPage";
import {useLang} from "./context/LanguageContext";
import setReviewDefaultLanguage from "./utils/fixReviews";
import {useState} from "react";
import VipPage from "./pages/VipPage";
import GenerateManySmallOddsPage from "./pages/Generations/GenerateManySmallOddsPage";

function App() {
    const { loaded, setHasPaid, setHasVip, setCurrentUser } = useAuth();
    const { setLanguage, betTranslationErrors } = useLang();
    const [ debugMenuActive, setDebugMenuActive ] = useState(false)

    if(!loaded){
        return (
            <div className="flex flex-col items-center justify-center h-screen">
                <Loading/>
            </div>
        )
    }

    return (
        <>
            <Router>
                <div className="bg-fixed bg-white min-h-screen">
                    <Routes>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/account" element={<AccountPage />} />
                        <Route path="/mysubscription" element={<MySubscriptionPage />} />
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/register" element={<RegisterPage />} />
                        <Route path="/forgotPassword" element={<ForgotPasswordPage />} />
                        <Route path="/terms" element={<TermsPage />} />
                        <Route path="/predictions" element={<PredictionsPage />} />
                        <Route path="/faq" element={<Faq/>} />
                        <Route path="/strategii" element={<StrategiiPage/>} />
                        <Route path="/soccer-high-odds" element={<SoccerHighOddsPage />} />
                        <Route path="/generate-small-odds" element={<GenerateSmallOddsPage />} />
                        <Route path="/generate-many-small-odds" element={<GenerateManySmallOddsPage />} />
                        <Route path="/generated-ticket" element={<GeneratedTicketPage />} />
                        <Route path="/winning-tickets" element={<WinningTicketsPage />} />
                        <Route path="/generate-high-odds" element={<GenerateHighOddsPage />} />
                        <Route path="/generated-high-odds" element={<GeneratedHighOddsTicket />} />
                        <Route path="/reviews" element={<ReviewsPage />} />
                        <Route path="/reviews/new" element={<LeaveReviewPage />} />
                        <Route path="/basketpage" element={<BasketPage />} />
                        <Route path="/tennispage" element={<TennisPage />} />
                        <Route path="/subscriptions" element={<SubscriptionsPage />} />
                        <Route path="/buySubscription/:id" element={<BuySubscriptionPage />} />
                        <Route path="/contest" element={<ContestPage />} />
                        <Route path="/vip" element={<VipPage />} />
                        <Route path="/howtouseapp" element={<HowToUsePage />} />
                    </Routes>
                </div>
            </Router>
            {process.env.REACT_APP_DEBUG === 'TRUE' &&
                <div>
                    { debugMenuActive &&
                        <div
                            style={{
                                position: "fixed",
                                width: "150px",
                                left: "0px",
                                top: "0px",
                                background: "rgba(0,0,0,0.4)",
                                height: "100vh",
                                padding: "10px",
                                zIndex: "1000",
                            }}
                        >
                            <button
                                style={{
                                    padding: "5px",
                                    background: 'gray',
                                    width: "100%",
                                    color: "white",
                                    marginTop: "10px"
                                }}
                                onClick={() => setHasPaid(true)}
                            >
                                Set paid true
                            </button>
                            <button
                                style={{
                                    padding: "5px",
                                    background: 'gray',
                                    width: "100%",
                                    color: "white",
                                    marginTop: "10px"
                                }}
                                onClick={() => setHasPaid(false)}
                            >
                                Set paid false
                            </button>
                            <button
                                style={{
                                    padding: "5px",
                                    background: 'gray',
                                    width: "100%",
                                    color: "white",
                                    marginTop: "10px"
                                }}
                                onClick={() => setHasVip(true)}
                            >
                                Set vip true
                            </button>
                            <button
                                style={{
                                    padding: "5px",
                                    background: 'gray',
                                    width: "100%",
                                    color: "white",
                                    marginTop: "10px"
                                }}
                                onClick={() => setHasVip(false)}
                            >
                                Set vip false
                            </button>
                            <button
                                style={{
                                    padding: "5px",
                                    background: 'gray',
                                    width: "100%",
                                    color: "white",
                                    marginTop: "10px"
                                }}
                                onClick={() => setCurrentUser({userId: "ceva aici"})}
                            >
                                Set user
                            </button>
                            <button
                                style={{
                                    padding: "5px",
                                    background: 'gray',
                                    width: "100%",
                                    color: "white",
                                    marginTop: "10px"
                                }}
                                onClick={() => setLanguage('ro')}
                            >
                                Română
                            </button>
                            <button
                                style={{
                                    padding: "5px",
                                    background: 'gray',
                                    width: "100%",
                                    color: "white",
                                    marginTop: "10px"
                                }}
                                onClick={() => setLanguage('es')}
                            >
                                Español
                            </button>
                            <button
                                style={{
                                    padding: "5px",
                                    background: 'gray',
                                    width: "100%",
                                    color: "white",
                                    marginTop: "10px"
                                }}
                                onClick={() => setLanguage('en')}
                            >
                                English
                            </button>
                            <button
                                style={{
                                    padding: "5px",
                                    background: 'gray',
                                    width: "100%",
                                    color: "white",
                                    marginTop: "10px"
                                }}
                                onClick={() => console.log(betTranslationErrors)}
                            >
                                show betTranslationErrors
                            </button>
                            <button
                                style={{
                                    padding: "5px",
                                    background: 'gray',
                                    width: "100%",
                                    color: "white",
                                    marginTop: "10px"
                                }}
                                onClick={() => setReviewDefaultLanguage()}
                            >
                                update Reviews
                            </button>

                            <button
                                style={{
                                    position: "fixed",
                                    bottom: "10px",
                                    left: "10px",
                                    padding: "5px",
                                    background: 'gray',
                                    width: "130px",
                                    color: "white",
                                }}
                                onClick={() => setDebugMenuActive(false)}
                            >
                                hide debug
                            </button>
                        </div>
                    }

                    {!debugMenuActive &&
                        <button
                            style={{
                                position: "fixed",
                                bottom: "10px",
                                left: "10px",
                                padding: "5px",
                                background: 'gray',
                                width: "130px",
                                color: "white",
                            }}
                            onClick={() => setDebugMenuActive(true)}
                        >
                            show debug
                        </button>
                    }
                </div>
            }
        </>
    );
}

export default App;
